<main class="homepage">
  <div class="head flexContent16 flex-column">
    <div>
      <h1 class="font-s48 mb-0">{{ "general.userManual" | translate }}</h1>
    </div>
    <div class="btns" *ngIf="this.user.IsWorker">
      <div
        class="btn w-180px trader"
        [ngClass]="{ activeBtn: isTraderActive }"
        (click)="isTraderActive = true; isWorkerActive = false"
      >
        {{ "structure.forTrader" | translate }}
      </div>
      <div
        class="btn w-180px worker"
        [ngClass]="{ activeBtn: isWorkerActive }"
        (click)="isWorkerActive = true; isTraderActive = false"
      >
        {{ "structure.forWorker" | translate }}
      </div>
    </div>
  </div>

  <div class="main_component">
    <div class="cards-wrapper m-auto">
      <div class="guides-wrapper" id="guides">
        <div class="guides-section-wrapper">
          <div
            class="guides-section"
            *ngFor="let item of guide"
          >
            <h3>{{ item.title }}</h3>

            <div class="guides-items-wrapper">
              <ng-container *ngFor="let guide of getGuideElementsToDisplay(item.id)">
                <div class="guide-items">
                  <div
                    *ngIf="guide.type == 'pdf'"
                    class="guide-item__icon"
                  ></div>
                  <div
                    *ngIf="guide.type == 'video'"
                    class="guide-video__icon"
                  ></div>
                  <div
                    *ngIf="guide.type == 'link'"
                    class="guide-link__icon"
                  ></div>
                  <div class="guide-item__content">
                    <div class="guide-item__text font-s14 font-w600">
                      <a target="_blank" href="{{ guide.path }}">{{
                        guide.name
                      }}</a>
                    </div>
                    <div class="guide-item__size">{{ guide.size }}</div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
